import { resolve } from '../di';
import { DpEventBus } from './DpEventBus';

export const eventBus = (): DpEventBus => resolve(DpEventBus);
